import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { BlogHomepageCardDetailsType, FeatureImage } from 'src/types';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import BackButton from '@components/back-button';
import { BrowserType, ROUTES } from '@constants/common';
import { PlatformType } from '@invideoio/web-shared/constants/common';

interface PlatformHeaderSection extends BlogHomepageCardDetailsType {
  bannerImage: FeatureImage;
  bgColor: string;
  platform: PlatformType;
  browser: BrowserType;
}

const PlatformHeaderSection = (props: PlatformHeaderSection) => {
  const { name, description, slug, bannerImage, bgColor, platform, browser } =
    props;
  return (
    <section
      style={{ background: bgColor }}
      className={ivclass(
        'iv-relative',
        'iv-pt-[126px] sm:iv-pt-[39px]',
        'iv-pb-[95px] lg:iv-pb-[98px]',
        'md:iv-h-[740px] sm:iv-h-[533px]',
      )}
    >
      <ImageComponent
        elementype={'native'}
        src={bannerImage?.url || ''}
        alt="platform-banner-img"
        className={ivclass(
          'iv-absolute iv-right-0 iv-bottom-0 ',
          'iv-h-[390px]',
          'md:iv-h-[420px]',
          'sm:iv-h-[310px]',
        )}
      />
      <div className={ivclass('iv-container iv-mx-auto')}>
        <div className={ivclass('iv-grid iv-grid-cols-12')}>
          <div
            className={ivclass(
              'iv-col-span-7 md:iv-col-span-8 sm:iv-col-span-12',
              'iv-col-start-2 md:iv-col-start-1 sm:iv-col-start-1',
              'lg:iv-mx-[-5px]',
              'sm:iv-text-center',
            )}
          >
            <h1
              className={ivclass(
                'iv-text-heading-4xl iv-font-extrabold',
                'md:iv-text-heading-3xl sm:iv-text-heading-m',
                'iv-text-grey-0',
                'iv-mx-20 lg:iv-mx-[0] md:iv-mx-[55px]',
                'iv-mb-[25px] lg:iv-mb-[22px] md:iv-mb-30 sm:iv-mb-[17px]',
                'sm:iv-pl-7',
              )}
            >
              {name}
            </h1>
            <div
              className={ivclass(
                'iv-text-heading-2xs iv-font-semibold',
                'sm:iv-text-body-3xl sm:iv-font-bold',
                'iv-text-grey-0',
                'iv-mx-20 lg:iv-mx-[0] md:iv-mx-[55px]',
                'iv-mb-[68px] md:iv-mb-[48px] sm:iv-mb-[22px]',
                'md:iv-pr-15',
                'sm:iv-px-10',
              )}
            >
              {description}
            </div>
            <div
              className={ivclass(
                'iv-mx-20 lg:iv-mx-[0] md:iv-mx-[55px]',
                'sm:iv-flex sm:iv-justify-center',
              )}
            >
              <BackButton
                isDark={false}
                buttonContent="Back to platforms"
                redirectLink={ROUTES.PLATFORMS}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformHeaderSection;
